import { defineStore } from 'pinia'
import Vue from 'vue'
import { computed, ref } from '@vue/composition-api'
import { fetchLiveSports, fetchLiveMatchesCount } from '@ms/api/match'
import { useState } from '@ms/utils/useState'
import { getStorage, setStorage } from '@ms/utils/storage'
import { batchUpdateSportsMap } from './sports/map.js'

const KEY_SPORTS_LIVE = 'sportsLive'

// live sports store
export const useSportsLiveStore = defineStore('sportsLive', () => {
  const defaultLiveSports = getStorage(KEY_SPORTS_LIVE, [], 'session')
  const tempLiveSportsCount = ref({})
  const {
    state: liveSports,
    loading: loadingLiveSports,
    setState,
    request: getLiveSports
  } = useState(defaultLiveSports, {
    fetchData: async () => {
      const { error, data } = await fetchLiveSports()
      if (error) return { error }
      return { data: parseLiveSports(data) }
    }
  })

  // 过滤没有比赛后的 live sports 列表
  const liveSportsValid = computed(() => liveSports.value.filter((x) => x.count > 0))

  const parseLiveSports = ({ sports }) => {
    setStorage(KEY_SPORTS_LIVE, sports, 'session')
    return sports
  }

  const setBffLiveSports = (data) => {
    const { sports } = data
    const list = parseLiveSports(data)
    setState(list)
    batchUpdateSportsMap(sports)
  }

  const getLiveSportsCount = (sportId = '') => {
    const sportInfo = liveSports.value.find((x) => x.sportId === sportId)
    if (sportInfo) {
      return sportInfo.count || 0
    } else if (tempLiveSportsCount.value.sportId === sportId) {
      return tempLiveSportsCount.value.count
    }
  }

  // 更新指定 live sport 比賽數量
  const updateLiveSportCount = (sportId = '', count = 0) => {
    if (count === null || count === undefined) count = 0
    const sportInfo = liveSports.value.find((x) => x.sportId === sportId)
    if (sportInfo) {
      if (sportInfo.count === count) return
      Vue.set(sportInfo, 'count', count)
    } else {
      tempLiveSportsCount.value = { sportId, count }
    }
  }

  /**
   * 获取指定 Live sport 比赛数量
   */
  async function fetchLiveCountById(sportId = '') {
    const { error, data } = await fetchLiveMatchesCount(sportId)
    if (!error) {
      updateLiveSportCount(sportId, data.count)
    }
  }

  return {
    liveSports,
    liveSportsValid,
    loadingLiveSports,
    getLiveSports,
    setBffLiveSports,
    getLiveSportsCount,
    updateLiveSportCount,
    fetchLiveCountById
  }
})
